import { usePageModels } from '@/context/PageModels';
import qs from 'query-string';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useStorageState } from 'react-storage-hooks';
import { AppContext } from '@/store';

const LangRedirectionByLocation = () => {
  const {
    state: { hrefLang = [] },
  } = React.useContext(AppContext);
  const { langToRedirect = '' } = usePageModels();
  const [hasAttempt, setHasAttempt] = useStorageState<boolean>(
    localStorage,
    'ATTEMPT.LANG_REDIRECTION_BY_LOCATION',
    false,
  );
  const location = useLocation();
  const queryParams = React.useMemo(() => qs.parse(location.search), [location.search]);
  const hasQueryParams = React.useMemo(
    () => !!Object.keys(queryParams || {})?.length,
    [queryParams],
  );

  const redirectByLocation = React.useCallback(() => {
    // DO NOT REDIRECT if the URL comes with query params, prevent future redirection.
    if (hasQueryParams) {
      return;
    }

    const url = hrefLang?.find((entry) => entry.hreflang === langToRedirect)?.href;
    // IF THERE IS NO URL then DON'T redirect and prevent future redirection.
    if (!url) {
      return;
    }

    window.location.href = url;
  }, [hasQueryParams, hrefLang, langToRedirect]);

  React.useEffect(() => {
    if (hasAttempt) return;
    // `hrefLag` is an async value. It needs to be filled before redirecting.
    if (!hrefLang?.length) return;
    setHasAttempt(true);

    if (!langToRedirect) return;

    redirectByLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAttempt, hrefLang?.length, langToRedirect, redirectByLocation]);

  return null;
};

export default LangRedirectionByLocation;
